export default "__VITE_ASSET__k7CqQ0LV__"